//import { triggerBase64Download } from 'react-base64-downloader';
import React from 'react';
import {adjuntoService} from '../_services';
import { Modal } from 'react-bootstrap';

export default class Descargador extends React.Component {


    state={
        showImage:false,
        base64String: undefined
    }

    handleClose = () =>{
        this.setState({showImage:false, base64String: undefined})
    }

    buscarYDescargar = (documento) => {
        //Busco la base 64

        const {url} = documento;

        const linkSource = `${url}`;
        this.setState({showImage: true, base64String: linkSource})

    }

    descargaLocal = (documento) => {

        const linkSource = `${documento.base64}`;
        this.setState({showImage: true, base64String:  linkSource})

    }

    render() {
        const {documento, nombre} = this.props;

        const isImage = documento.type == undefined || documento.type == null || documento.type.startsWith('image');

        if (documento) {
            return (
                <>
                    <div className='form-textUpload' style={{cursor: 'pointer'}}
                        onClick={() => documento.temp ? this.descargaLocal(documento) : this.buscarYDescargar(documento)}>
                        Ver {documento.temp ? documento.nombre : nombre}
                    </div>

                    <Modal size="lg" show={this.state.showImage} onHide={this.handleClose}>
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                            {isImage ?
                            <img className='w-100' src={this.state.base64String}></img>:
                            <video controls={true} className='w-100' src={this.state.base64String}> </video>    
                        }
                        </Modal.Body>
                    </Modal>
                </>

            );
        } else {
            return ('')
        }

    }
}
